// removed by extract-text-webpack-plugin
module.exports = {"tankTTC":"TankInfo_tankTTC--130Zb","tankTtc":"TankInfo_tankTTC--130Zb","titleTTC":"TankInfo_titleTTC--2zdEK","titleTtc":"TankInfo_titleTTC--2zdEK","containerTTC":"TankInfo_containerTTC--2en_u","containerTtc":"TankInfo_containerTTC--2en_u","itemTTC":"TankInfo_itemTTC--vxIEb","itemTtc":"TankInfo_itemTTC--vxIEb","nameTTC":"TankInfo_nameTTC--3kBsx","nameTtc":"TankInfo_nameTTC--3kBsx","valueTTC":"TankInfo_valueTTC--ySyqS","valueTtc":"TankInfo_valueTTC--ySyqS","value":"TankInfo_value--8FG8L","tankopediaLink":"TankInfo_tankopediaLink--1BlXL"};


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXRewardsTank/components/TankInfo/TankInfo.scss
// module id = 2442
// module chunks = 11